import { initialStateOptions } from '@/utils/pagination-utils';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  filterBySaving: false,
  selectedStatus: null,
  searchText: null,
  empresa: null,
  localEntrega: null,
  centroCusto: [],
  produto: [],
  projeto: [],
  responsavel: [],
  dataInicial: null,
  dataFinal: null,
  dataFaturamentoInicial: null,
  dataFaturamentoFinal: null,
  grupo: [],
  fornecedor: [],
  listOptions: initialStateOptions('dataCompra'),
  camposPersonalizados: null,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
